{
  "pages": {
    "Connect": {
      "total_connections": "Total connections",
      "active_connections": "Active connections",
      "total_volume": "Total volume",
      "usd": "MVR",
      "oauth2_connections": "OAuth2 connections",
      "add_connection": "Add connection",
      "attrs": {
        "search_by_app_name_api_key": "Search by app name, API key, or domain...",
        "eg_opera_pms_salesforce": "e.g., Opera PMS, Salesforce",
        "examplecom_apiexamplecom": "example.com, api.example.com"
      },
      "refresh": "Refresh",
      "connected": "Connected",
      "public_key": "Public key",
      "private_key": "Private key",
      "scopes": "Scopes",
      "domains": "Domains",
      "volume": "Volume",
      "transactions": "Transactions",
      "last_used": "Last used",
      "settings": "Settings",
      "no_connections_found": "No connections found",
      "no_connections_match_your_search_criteria": "No connections match your search criteria. Try adjusting your\n            filters.",
      "app_name": "App name",
      "authorized_domains": "Authorized domains",
      "commaseparated_list_of_domains": "Comma-separated list of domains",
      "cancel": "Cancel",
      "create_connection": "Create connection",
      "edit_connection": "Edit connection",
      "save_changes": "Save changes"
    },
    "PhysicalTerminals": {
      "total_terminals": "Total terminals",
      "online_terminals": "Online terminals",
      "physical_terminals": "Physical terminals",
      "attrs": {
        "search_by_name_serial_model_or": "Search by name, serial, model, or location..."
      },
      "serial": "Serial",
      "location": "Location",
      "last_connection": "Last connection",
      "firmware": "Firmware",
      "v": "v",
      "battery": "Battery",
      "view_details": "View details",
      "update_firmware": "Update firmware",
      "request_terminal": "Request Terminal",
      "no_terminals_found": "No terminals found",
      "no_terminals_match_your_search_criteria": "No terminals match your search criteria. Try adjusting your filters\n            or add a new terminal."
    },
    "SoftPosTerminals": {
      "total_devices": "Total devices",
      "active_devices": "Active devices",
      "softpos_terminals": "SoftPos terminals",
      "attrs": {
        "search_by_device_mid_tid_or": "Search by device, MID, TID, or owner..."
      },
      "android": "· Android",
      "owner": "Owner",
      "merchant_id": "Merchant ID",
      "terminal_id": "Terminal ID",
      "app_version": "App version",
      "update_app": "Update app",
      "no_softpos_terminals_found": "No SoftPos terminals found",
      "no_terminals_match_your_search_criteria": "No terminals match your search criteria. Try adjusting your filters\n            or register a new device."
    }
  }
}
